export const OAuthCallbackPage = () => {
  const queryParameters = new URLSearchParams(window.location.search);

  const bc = new BroadcastChannel("oauth_channel");

  bc.postMessage({
    webhookUrl: decodeURI(queryParameters.get("webhook_url") || ""),
    channel: queryParameters.get("channel"),
  });

  window.close();

  return <div />;
};
